import { api } from '@/shared/api/client';
import type { ResetPasswordPayload } from '../model/dto';

export const postAuthResetPassword = async (
  payload: ResetPasswordPayload
) => {
  const { data } = await api.post('/auth/reset-password/', payload);
  return data;
};
